const ArrowIcon = ({ strokeColor = '#808080' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <circle
      fill="#4d4d4d"
      cx="397.55"
      cy="397.55"
      r="388.66"
    />
    <circle
      fill="none"
      stroke={strokeColor}
      strokeWidth="50"
      strokeMiterlimit="10"
      cx="397.55"
      cy="397.55"
      r="372.55"
    />
    <circle
      fill="none"
      stroke="#fff"
      strokeWidth="20"
      strokeMiterlimit="10"
      cx="397.55"
      cy="397.55"
      r="343.4"
    />
    <path
      fill="#fcfcfc"
      d="M326.11,220.21c17.75-18.42,34.97-36.41,52.31-54.28,14.27-14.71,19.63-14.79,33.71-.56,
         46.47,46.99,92.9,94.04,139.33,141.07,2.24,2.27,4.54,4.51,6.56,6.97,7.68,9.4,7.45,19.3-.5,26.23-6.89,6.01-18.1,5-25.67-2.85,
         -19.26-20.01-37.93-40.6-57.57-60.23-19.86-19.85-40.82-43.83-60.33-62.39.04-.55-.09,6.74-.09,9.03,
         -0.04,131.57-0.05,263.15-0.06,394.72,0,2.56.22,5.13-.06,7.66-.25,2.34-1.48,4.91-3.18,7.33-6.02,
         8.55-18.43,10.08-25.74,2.6-1.1-1.12-1.99-2.37-2.56-3.73-.41-.96-.85-1.9-1.3-2.83-1.87-3.87-1.52-9.6-1.5-14.34,
         0.45-100.91,1.1-201.82,1.6-302.73.16-32.25.02-64.51.02-97.64-1.76,1.39-3.4,2.44-4.75,3.78-21.03,
         20.96-42.21,41.78-62.98,63-17.61,17.98-34.62,36.56-52.16,54.61-9.25,9.52-17.3,10.62-23.99,4.21-7.42-7.11-7.93-18.42,
         0.23-27.26,18.39-19.94,37.36-39.35,56.15-58.92,10.62-11.05,21.36-21.98,32.54-33.44Z"
    />
  </svg>
);

export default ArrowIcon;
